import { istParts } from '@/lib/ist'

/**
 * Lot code minted on the phone when a delivery starts (F4.2, R17):
 * HL-{YYYY}-{MMDD}-{device code_prefix}-{NNNN}; NNNN from the per-device daily counter
 * (offline/meta nextDailyCounter), never reused even if the delivery is voided.
 */
export function lotCode(args: {
  devicePrefix: string
  counter: number
  at: Date | number | string
}): string {
  const p = istParts(args.at)
  const mmdd = `${String(p.month).padStart(2, '0')}${String(p.day).padStart(2, '0')}`
  return `HL-${p.year}-${mmdd}-${args.devicePrefix.toUpperCase()}-${String(args.counter).padStart(4, '0')}`
}

export const LOT_CODE_RE = /^HL-\d{4}-\d{4}-[A-Z0-9]+-\d{4,}$/

/** "2026-10-18" + "10:05" (IST) → ISO instant. */
export function istInstant(dateKey: string, hhmm: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey) || !/^\d{2}:\d{2}$/.test(hhmm)) return null
  const d = new Date(`${dateKey}T${hhmm}:00+05:30`)
  return Number.isNaN(d.getTime()) ? null : d.toISOString()
}
